const animationCategories = ['prosthetics', 'conservative', 'parodontology'];
/*
*                 "Implantology"
*                 "Oral surgery / Periodontics"
*                 "Prosthodontics"
* "Conservative"
* "Orthodontics"
* */
export {animationCategories};
